import Axios, { AxiosResponse } from "axios"
import { encryptionController } from "controllers/EncryptionController"
import { activityLogHelper } from "helpers/activity_log"
import { ActivityItemDetail, ParamsActivityLogs } from "./activity-log.type"

export const getActivitiesMiddleware = async (
  params: ParamsActivityLogs,
  dbKey: string
) => {
  const response: AxiosResponse<{
    data: ActivityItemDetail[]
  }> = await Axios.get("api/activity-log", {
    params,
    headers: dbKey ? { "x-db-key": dbKey } : undefined,
  })
  return Promise.all(
    response.data.data.map(async (item) => {
      let result = await encryptionController().decrypt(item.content, {
        dataType: "string",
        type: "project",
      })
      if (item.param) {
        result = activityLogHelper.createStringFromTemplate(
          result,
          JSON.parse(item.param)
        )
      }
      return {
        ...item,
        content: result,
      }
    })
  )
}

export const postActionLogMiddleware = async (
  dataRequest: {
    content: string
    created_by: string
    model: string
    relation_id: string
    param?: any
  },
  loading: boolean
) => {
  const response = await Axios.post(
    `/api/activity-log/create?${loading ? "loading=0" : ""}`,
    dataRequest
  )
  return response.data.data
}
